import React from 'react';

const Status = ({ rowData }) => {
    return (
        <span>
            {
            rowData.status === "o" ? "جاری" : 
            rowData.status === "a" ? "تایید شده" :
            rowData.status === "r" ? "رد شده" :
            rowData.status === "e" ? "منقضی" :
            rowData.status === "d" ? "تکمیل شده" :
            rowData.status === "c" && "لغو شده"
            }
        </span>
    );
}

export default Status;
